import { useEffect, useRef } from 'react';
import { useSocketContext } from '../context/SocketContext';

/**
 * Listens for 'new_post' socket events and triggers a silent feed refresh
 * so recipients see new posts immediately without manual refresh.
 */
export default function FeedSocketListener({ getAllPosts }) {
  const { socket, isConnected } = useSocketContext();
  const getAllPostsRef = useRef(getAllPosts);
  getAllPostsRef.current = getAllPosts;

  useEffect(() => {
    if (!socket || !isConnected || typeof getAllPostsRef.current !== 'function') return;

    const handleNewPost = () => {
      getAllPostsRef.current?.(true);
    };

    socket.on('new_post', handleNewPost);
    return () => {
      socket.off('new_post', handleNewPost);
    };
  }, [socket, isConnected]);

  return null;
}
